import React, { useContext, useEffect, useRef, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { FaRegCalendarAlt } from "react-icons/fa";
import AuthContext from "../../../context/auth-context";
import UpperbarContext from "../../../context/upperbar-context";
import { AiOutlineSearch, AiTwotonePrinter } from "react-icons/ai";
import { RiFileExcel2Fill } from "react-icons/ri";
import { BsFileEarmarkPdfFill } from "react-icons/bs";
import { Fetchdata } from "../../../hooks/getData";
import Spinner from "../../../loading/spinner";
import "../../entry/voucher/voucher.css";
import { ToastContainer, toast } from "react-toastify";
import { GetCurrMonth, GetCurrYear } from "../../../hooks/dateConvertor";
import NepaliDate from "nepali-date-converter";
import { englishToNepaliNumber } from "nepali-number";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";
import { MdOutlineDelete } from "react-icons/md";
import ConfirmDetetePopup from "../../../hooks/confirmDeletePopup";

export default function GenerateSalary() {
  const { User } = useContext(AuthContext);
  const { fiscalYear, todayDate, appURL, darkText, mode } = useContext(UpperbarContext);

  const [loading, setLoading] = useState(true);
  const [staffData, setStaffData] = useState({});
  const [taxSlabList, setTaxSlabList] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [confirmPopup, setConfirmPopup] = useState(false);
  const [comSettings, setComSettings] = useState({
    Prov: 10,   // Default Provident Fund percentage
    SSF: 11,    // Default Employee SSF percentage
    ComSSF: 20  // Default Employer SSF percentage
  });

  const cur_year = new Date().getFullYear();
  const eYears = generateArrayOfYears(cur_year);
  const nYears = generateArrayOfNepYears(cur_year);
  
  const initalvalue = {
    year: GetCurrYear(),
    month: GetCurrMonth(),
  };
  const [formValues, setFormValues] = useState(initalvalue);
  const searchInput = useRef("");

  useEffect(() => {
    setFormValues(initalvalue);
    fetchCompanySettings();
    taxslablst();
  }, [mode]);

  // Fetch company settings from session
  const fetchCompanySettings = () => {
    const dataForm = {
      AuthCode: User.AuthCode,
      ComID: User.ComID,
      UserID: "1",
      CID: "1",
      Flag: "S",
      DFlag: "-1",
      MonthNp: `${formValues.year}/${formValues.month}`,
      FiscalID: User.FiscalID.toString(),
      BranchID: User.BranchID.toString(),
      Type: "POST",
      FetchURL: `${appURL}api/acc/admin/payroll-generate`,
    };

    Fetchdata(dataForm).then(function (result) {
      if (result.StatusCode === 200 && result.Values && result.Values.length > 0) {
        // Extract company settings from first staff member
        const firstStaff = result.Values[0];
        setComSettings({
          Prov: parseFloat(firstStaff.ComProv) || 10,
          SSF: parseFloat(firstStaff.SSFFund) || 11,
          ComSSF: parseFloat(firstStaff.ComSSF) || 20
        });
      }
    }).catch(() => {
      // Use default values if fetch fails
      setComSettings({
        Prov: 10,
        SSF: 11,
        ComSSF: 20
      });
    });
  };

  function getNepaliDate() {
    return new NepaliDate().getBS();
  }

  function generateArrayOfYears(cur_year) {
    const max = cur_year;
    const min = 2022;
    const years = [];
    for (let i = max; i >= min; i--) years.push(i);
    return years;
  }

  function generateArrayOfNepYears(cur_year) {
    let nCur_date = getNepaliDate();
    const max = nCur_date.year;
    const min = 2079;
    const years = [];
    for (let i = min; i <= max; i++) years.push(i);
    return years;
  }

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  // Calculate Provident Fund and SSF based on Basic Salary
  const calculatePFAndSSF = (staff, basicSalary) => {
    Object.keys(staff).forEach(head => {
      const details = staff[head];
      if (!details) return;
      
      // Handle Provident Fund
      if (details.Head === "Provident Fund") {
        details.Amount = (basicSalary * comSettings.Prov / 100).toFixed(2);
      } 
      // Handle SSF+ (Employer SSF - Addition)
      else if (details.Head === "SSF (+)") {
        details.Amount = (basicSalary * comSettings.ComSSF / 100).toFixed(2);
      }
      // Handle SSF- (Employee SSF - Deduction)
      else if (details.Head === "SSF (-)") {
        details.Amount = (basicSalary * comSettings.SSF / 100).toFixed(2);
      }
    });
  };

  // Calculate tax based on tax slabs
  const calculateTax = (staff, taxSlabs) => {
    let taxableIncome = 0;
    
    Object.keys(staff).forEach(head => {
      const details = staff[head];
      if (!details || head === "Designation") return;
      
      const amount = parseFloat(details.Amount || 0);
      
      // Additions (A) that are taxable
      if (details.HeadType === 'A' && details.IsTax === 'Y') {
        taxableIncome += amount;
      }
      // Deductions (R) that reduce taxable income
      if (details.HeadType === 'R' && details.IsTax === 'Y' && details.Head !== "Tax") {
        taxableIncome -= amount;
      }
    });

    const annualTaxableIncome = taxableIncome * 12;
    let taxAmount = 0;
    let remainingIncome = annualTaxableIncome;
    
    const sortedSlabs = [...taxSlabs].sort((a, b) => a.IncomeFrom - b.IncomeFrom);
    
    sortedSlabs.forEach((slab) => {
      const slabMin = parseFloat(slab.IncomeFrom);
      const slabMax = parseFloat(slab.IncomeTo);
      const slabRate = parseFloat(slab.TaxRate) / 100;
      
      if (remainingIncome <= 0) return;
      
      let taxableInSlab = 0;
      if (remainingIncome > slabMin) {
        taxableInSlab = Math.min(remainingIncome, slabMax) - slabMin;
        if (taxableInSlab > 0) {
          taxAmount += taxableInSlab * slabRate;
          remainingIncome -= taxableInSlab;
        }
      }
    });

    const monthlyTax = taxAmount / 12;
    
    Object.keys(staff).forEach(head => {
      const details = staff[head];
      if (details?.Head === "Tax") {
        details.Amount = monthlyTax.toFixed(2);
      }
    });
  };

  // Calculate overtime based on basic salary
  const calculateOvertime = (staff, basicSalary) => {
    Object.keys(staff).forEach(head => {
      const details = staff[head];
      if (!details) return;
      
      // Handle Overtime (Type O)
      if (details.Type === "OT") {
        // Monthly working hours = 4 hours/day * 30 days = 120
      
        const perHour = basicSalary / details.DayCt;
       
        const overtimeHours = parseFloat(details.OverTimeCt || 0);
        details.Amount = (perHour * overtimeHours * 1.5).toFixed(2);
      }
    });
  };

  // Calculate absent deduction based on basic salary
const calculateAbsent = (staff, basicSalary) => {
  let dayCt = 0;
  let absentCt = 0;
  let leaveAllowedCt = 0;
  let netAbsentDays = 0;

  Object.keys(staff).some(head => {
    if (head === "Designation") return false;
    const details = staff[head];
    if (details.Type === "A") {
      dayCt = parseFloat(details.DayCt || 0);
      absentCt = parseFloat(details.AbsentCt || 0);
      leaveAllowedCt = parseFloat(details.LeaveAllowedCt || 0);
      return true;
    }
    return false;
  });

  if (dayCt > 0) {
    const diff = absentCt - leaveAllowedCt;

    if (diff > 0) {
      console.log("CASE 1: AbsentCt > LeaveAllowedCt");
      console.log(`AbsentCt: ${absentCt}, LeaveAllowedCt: ${leaveAllowedCt}, NetAbsentDays: ${diff}`);
      netAbsentDays = diff;
    } else {
      console.log("CASE 2: AbsentCt <= LeaveAllowedCt — No deduction");
      netAbsentDays = 0;
    }

    const perDayAmount = basicSalary / dayCt;
    const absentAmount = perDayAmount * netAbsentDays;

    Object.keys(staff).forEach(head => {
      const details = staff[head];
      if (details?.Head === "Absent") {
        details.Amount = absentAmount.toFixed(2);
        details.NetAbsent = netAbsentDays; // 👈 Add this to store for display
      }
    });
  }
};



  // Fetch staff salary data
  useEffect(() => {
    staffLst();
  }, [formValues.year, formValues.month, mode]);

  const staffLst = () => {
    setLoading(true);
    const UserID = "" + User.UID;
    const Branch = "" + User.BranchID;
    const Fiscal = "" + User.FiscalID;

    const dataForm = {
      AuthCode: User.AuthCode,
      ComID: User.ComID,
      UserID: UserID,
      CID: "1",
      Flag: "S",
      DFlag: "-1",
      MonthNp: `${formValues.year}/${formValues.month}`,
      BranchID: Branch,
      FiscalID: Fiscal,
      Type: "POST",
      FetchURL: `${appURL}api/acc/admin/payroll-generate`,
    };

    Fetchdata(dataForm).then(function (result) {
      if (result.StatusCode === 200) {
        const postResult = result.Values || [];
        
        // Group data by staff
        const groupedByName = postResult.reduce((acc, curr) => {
          if (!acc[curr.FullName]) acc[curr.FullName] = [];
          acc[curr.FullName].push(curr);
          return acc;
        }, {});
        
        // Create staff list
        const newStaffList = Object.keys(groupedByName).map(name => ({
          FullName: name,
          Designation: groupedByName[name][0].Designation,
          data: groupedByName[name],
        }));
        
        // Get all unique heads
        const uniqueHead = [...new Set(postResult.map(item => item.Head))];
        
        // Create staff data structure
        const newData = {};
        newStaffList.forEach(item => {
          newData[item.FullName] = {};
          newData[item.FullName]["Designation"] = item.data[0].Designation;

          uniqueHead.forEach(head => {
            const data = item.data.find(d => d.Head === head);
            if (data) {
              newData[item.FullName][head] = {
                ...data,
                Amount: data.Amount === "NaN" ? "0" : data.Amount
              };
            }
          });
          
          // Add mandatory salary heads if missing
          const mandatoryHeads = [
            { Head: "Provident Fund", Type: "P", HeadType: "R", IsTax: "N" },
            { Head: "SSF (+)", Type: "SSF+", HeadType: "A", IsTax: "N" },
            { Head: "SSF (-)", Type: "SSF-", HeadType: "R", IsTax: "N" },
            // { Head: "Tax", Type: "T", HeadType: "R", IsTax: "N" },
            // { Head: "Absent Deduction", Type: "A", HeadType: "R", IsTax: "N" },
            // { Head: "Overtime", Type: "O", HeadType: "A", IsTax: "Y" },
          ];
          
          mandatoryHeads.forEach(headInfo => {
            if (!newData[item.FullName][headInfo.Head]) {
              newData[item.FullName][headInfo.Head] = {
                StaffID: item.data[0].StaffID,
                FullName: item.FullName,
                Designation: item.Designation,
                Head: headInfo.Head,
                HeadID: "",
                HeadType: headInfo.HeadType,
                Type: headInfo.Type,
                IsTax: headInfo.IsTax,
                AbsentCt: headInfo.AbsentCt,
                OverTimeCt: headInfo.OverTimeCt,
                LeaveAllowedCt: headInfo.LeaveAllowedCt,
                DayCt: headInfo.DayCt,
                ProvFund: headInfo.ProvFund,
                SSFFund: headInfo.SSFFund,
                Amount: headInfo.Amount
              };
            }
          });
        });

        // Calculate values for each staff
        Object.keys(newData).forEach(fullName => {
          const staff = newData[fullName];
          
          // 1. Find basic salary
          let basicSalary = 0;
          Object.keys(staff).forEach(head => {
            if (staff[head]?.Type === 'B') {
              basicSalary = parseFloat(staff[head].Amount) || 0;
            }
          });
          
          // 2. Calculate Provident Fund and SSF
          calculatePFAndSSF(staff, basicSalary);
          
          // 3. Calculate Overtime
          calculateOvertime(staff, basicSalary);
          
          // 4. Calculate Absent
          calculateAbsent(staff, basicSalary);
          
          // 5. Calculate Tax
          if (taxSlabList.length > 0) {
            calculateTax(staff, taxSlabList);
          }
        });
        
        setStaffData(newData);
      } else {
        setStaffData({});
      }
      setLoading(false);
    }).catch(() => {
      setLoading(false);
      setStaffData({});
    });
  };

  // Fetch tax slabs
  const taxslablst = () => {
    const dataForm = {
      AuthCode: User.AuthCode,
      ComID: User.ComID,
      UserID: "-1",
      DFlag: "TAXSLAB",
      Flag: "S",
      CID: "1",
      Type: "POST",
      FetchURL: `${appURL}api/acc/admin/ref-values`,
    };

    Fetchdata(dataForm).then(function (result) {
      if (result.StatusCode === 200) {
        setTaxSlabList(result.Values || []);
      }
    });
  };

  const handleInputChange = (fullName, head, fieldName, fieldValue) => {
    setStaffData(prev => {
      const updatedData = { ...prev };
      const staff = updatedData[fullName];
      const details = staff[head];
      
      // Update the changed value
      details[fieldName] = fieldValue;
      
      // Re-fetch the basic salary for this staff
      let basicSalary = 0;
      Object.keys(staff).forEach(h => {
        if (staff[h]?.Type === 'B') {
          basicSalary = parseFloat(staff[h].Amount || 0);
        }
      });
      
      // Recalculate all components
      calculatePFAndSSF(staff, basicSalary);
      calculateOvertime(staff, basicSalary);
      calculateAbsent(staff, basicSalary);
      if (taxSlabList.length > 0) {
        calculateTax(staff, taxSlabList);
      }
      
      return updatedData;
    });
  };

  const handleSubmit = () => setIsSubmit(true);
  const handleGenerate = () => generateOrReverse("V");
  const handleReverse = () => generateOrReverse("RV");

  const generateOrReverse = (flag) => {
    const dataForm = {
      AuthCode: User.AuthCode,
      ComID: User.ComID,
      UserID: User.UID.toString(),
      CID: "1",
      Flag: flag,
      DFlag: "-1",
      MonthNp: `${formValues.year}/${formValues.month}`,
      BranchID: User.BranchID.toString(),
      FiscalID: User.FiscalID.toString(),
      Type: "POST",
      FetchURL: `${appURL}api/acc/admin/payroll-generate`,
    };

    Fetchdata(dataForm).then(result => {
      if (result.StatusCode === 200) {
        staffLst();
        toast.success(result.Message, { theme: "light" });
      } else {
        toast.error("Error: " + result.Message, { theme: "light" });
      }
    });
  };

  const searchHandler = (e) => {
    const searchQuery = searchInput.current.value.toLowerCase();
    if (searchQuery) {
      const filteredData = Object.entries(staffData).filter(([name]) => 
        name.toLowerCase().includes(searchQuery)
      );
      setStaffData(Object.fromEntries(filteredData));
    } else {
      staffLst();
    }
  };

  const handleKeyPress = (event) => {
    if (isNaN(Number(event.key)) && event.key !== '.') event.preventDefault();
  };

  // Prepare data for submission
  useEffect(() => {
    if (!isSubmit) return;
    
    const allStaffData = Object.values(staffData)
      .flatMap(staff => 
        Object.entries(staff)
          .filter(([key]) => key !== "Designation")
          .map(([, details]) => details)
      );
      
    const dataForm = {
      AuthCode: User.AuthCode,
      ComID: User.ComID,
      UserID: User.UID.toString(),
      CID: "1",
      Flag: "i",
      DFlag: "-1",
      MonthNp: `${formValues.year}/${formValues.month}`,
      Values: allStaffData,
      BranchID: User.BranchID.toString(),
      FiscalID: User.FiscalID.toString(),
      Type: "POST",
      FetchURL: `${appURL}api/acc/admin/payroll-generate`,
    };

    Fetchdata(dataForm).then(result => {
      if (result.StatusCode === 200) {
        toast.success(result.Message, { theme: "light" });
      } else {
        toast.error("Error: " + result.Message, { theme: "light" });
      }
      setIsSubmit(false);
    });
  }, [isSubmit]);

  // Calculate row totals
  const getRowTotal = (staff) => {
    let totalAdditions = 0;
    let totalDeductions = 0;
    
    Object.keys(staff).forEach(head => {
      if (head === "Designation") return;
      
      const details = staff[head];
      if (!details) return;
      
      const amount = parseFloat(details.Amount || 0);
      
      if (details.HeadType === 'A') {
        totalAdditions += amount;
      } else if (details.HeadType === 'R') {
        totalDeductions += amount;
      }
    });
    
    return (totalAdditions - totalDeductions).toFixed(2);
  };

  // Calculate column totals
  const getColumnTotal = (head) => {
    return Object.values(staffData).reduce((sum, staff) => {
      const details = staff[head];
      return sum + (details ? parseFloat(details.Amount || 0) : 0);
    }, 0).toFixed(2);
  };

  // Calculate grand total
  const getGrandTotal = () => {
    return Object.values(staffData).reduce((total, staff) => {
      return total + parseFloat(getRowTotal(staff));
    }, 0).toFixed(2);
  };

  const updateRequest = () => setConfirmPopup(true);

  // Get all unique heads for the table
  const getAllHeads = () => {
    const heads = new Set();
    Object.values(staffData).forEach(staff => {
      Object.keys(staff).forEach(head => {
        if (head !== "Designation") {
          heads.add(head);
        }
      });
    });
    return Array.from(heads);
  };

  const allHeads = getAllHeads();

  return (
    <div className="container-fluid classatten-wrapper ps-4 pe-4">
      <div className="row ">
        <div className="page-header">
          <div className="text-start page-title" style={darkText}>
            {mode === "en" ? "Generate Salary" : "तलब उत्पन्न गर्नुहोस्"}
          </div>
          <div className="page-date">
            <div className="sec-content" style={darkText}>
              <FaRegCalendarAlt /> {todayDate} <span>|</span>{" "}
              {mode === "en" ? "Fiscal Year" : "वित्तीय वर्ष"} :{" "}
              {fiscalYear.StartDate}-{fiscalYear.EndDate}
            </div>
          </div>
        </div>
        <hr className="title-hr" />
      </div>

      <div className="sec-dataTable">
        <div className="upper-dataTbl pb-2">
          <div className="uk-flex uk-flex-wrap uk-flex-between uk-flex-middle">
            <div className="uk-flex uk-flex-wrap uk-flex-bottom me-3">
              <div className="me-2 mt-3">
                <label className="d-block text-start dark-gray mb-1">
                  {mode === "en" ? "Select Month" : "महिना चयन गर्नुहोस्"}
                </label>
                <select
                  className="form-select form-select-sm"
                  name="month"
                  onChange={handleOnChange}
                  value={formValues.month}
                >
                  <option value="01">Baishakh</option>
                  <option value="02">Jestha</option>
                  <option value="03">Ashadh</option>
                  <option value="04">Shrawan</option>
                  <option value="05">Bhadra</option>
                  <option value="06">Ashwin</option>
                  <option value="07">Kartik</option>
                  <option value="08">Mangsir</option>
                  <option value="09">Poush</option>
                  <option value="10">Magh</option>
                  <option value="11">Falgun</option>
                  <option value="12">Chaitra</option>
                </select>
              </div>
              <div className="me-2 mt-3">
                <label className="d-block text-start dark-gray mb-1">
                  {mode === "en" ? "Select Year" : "वर्ष चयन गर्नुहोस्"}
                </label>
                <select
                  className="form-select form-select-sm"
                  name="year"
                  onChange={handleOnChange}
                  value={formValues.year}
                >
                  {nYears.map(year => (
                    <option key={year} value={year}>{year}</option>
                  ))}
                </select>
              </div>
              <div className="me-2 mt-3">
                <button
                  type="button"
                  className="btn btn-sm"
                  style={{ background: "var(--button-color)", color: "white" }}
                  onClick={handleSubmit}
                >
                  {mode === "en" ? "Save" : "बुझाउनुहोस्"}
                </button>
              </div>
              <div className="me-2 mt-3">
                <button
                  type="button"
                  className="btn btn-sm"
                  style={{ background: "var(--button-color)", color: "white" }}
                  onClick={handleGenerate}
                >
                  {mode === "en" ? "Generate Voucher" : "वाउचर उत्पन्न गर्नुहोस्"}
                </button>
              </div>
              <div className="me-2 mt-3">
                <button
                  type="button"
                  className="btn btn-sm"
                  style={{ background: "var(--button-color)", color: "white" }}
                  onClick={handleReverse}
                >
                  {mode === "en" ? "Reverse Voucher" : "वाउचर उल्टो गर्नुहोस्"}
                </button>
              </div>
              <div className="me-2 mt-3">
                <div className="ln-verition d-flex uk-flex-center">
                  <button
                    type="button"
                    className="btn btn-sm deletespan mx-1"
                    onClick={updateRequest}
                    uk-tooltip={mode === "en" ? "Delete" : "हटाउनुहोस्"}
                  >
                    <MdOutlineDelete />
                  </button>
                </div>
              </div>
            </div>

            <div>
              <div className="d-flex uk-flex-middle uk-flex-right">
                <div className="export-btn">
                  <button uk-tooltip="Export Excel" className="me-1 ms-2 border-0">
                    <RiFileExcel2Fill size="1rem" color="#136438" />
                  </button>
                </div>
                <div className="export-btn">
                  <button uk-tooltip="Export Pdf" className="mx-1 border-0">
                    <BsFileEarmarkPdfFill size="1rem" color="#ff0002" />
                  </button>
                </div>
                <div className="export-btn">
                  <button uk-tooltip="Print" className="mx-1 border-0">
                    <AiTwotonePrinter size="1rem" color="#555" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="w-100 mb-3 mt-3">
          <div className="d-flex uk-flex-middle justify-content-end">
            <div>
              <form className="uk-search uk-search-default">
                <AiOutlineSearch className="search-icon" />
                <input
                  placeholder={mode === "en" ? "Search" : "खोजी गर्नुहोस्"}
                  ref={searchInput}
                  type="text"
                  className="form-control form-control-sm searchField"
                  onChange={searchHandler}
                />
              </form>
            </div>
          </div>
        </div>

        <div className="mt-3 tableHeight show-scrollbar" style={{ maxHeight: "400px" }}>
          {loading ? (
            <Spinner />
          ) : Object.keys(staffData).length ? (
            <table className="uk-table reportTable voucher-table">
              <thead>
                <tr>
                  <td className="rdt_TableHeadRow tableHead text-center" width="70px">
                    {mode === "en" ? "S.N." : "क्र.सं"}
                  </td>
                  <td className="rdt_TableHeadRow tableHead sticky-left" width="200px">
                    {mode === "en" ? "Name" : "नाम"}
                  </td>
                  <td className="rdt_TableHeadRow tableHead" width="200px">
                    {mode === "en" ? "Designation" : "पद"}
                  </td>
                  {allHeads.map(head => (
                    <td className="rdt_TableHeadRow tableHead" key={head}>
                      {head}{" "}
                      {staffData[Object.keys(staffData)[0]]?.[head]?.HeadType === 'A' ? (
                        <FaArrowUp />
                      ) : staffData[Object.keys(staffData)[0]]?.[head]?.HeadType === 'R' ? (
                        <FaArrowDown />
                      ) : null}
                    </td>
                  ))}
                  <td className="rdt_TableHeadRow tableHead text-end sticky-right" width="150px">
                    {mode === "en" ? "Total" : "कुल"}
                  </td>
                </tr>
              </thead>

              <tbody>
                {Object.keys(staffData).map((fullName, i) => (
                  <tr key={fullName}>
                    <td className="rdt_TableCell tablecell text-center">
                      {mode === "en" ? i + 1 : englishToNepaliNumber(i + 1)}
                    </td>
                    <td className="rdt_TableCell tablecell text-start sticky-left">
                      {fullName}
                    </td>
                    <td className="rdt_TableCell tablecell text-start">
                      {staffData[fullName].Designation}
                    </td>
                    {allHeads.map(head => {
                      const data = staffData[fullName][head];
                      if (!data) {
                        return (
                          <td 
                            className="rdt_TableCell tablecell voucherCell text-end" 
                            key={head}
                          >
                            -
                          </td>
                        );
                      }
                      
                      // Auto-calculated fields: Provident Fund, SSF (+), SSF (-), Tax, Absent, Overtime
                      const autoCalculated = [
                        "Provident Fund", 
                        "SSF (+)", 
                        "SSF (-)", 
                        "Tax", 
                        "Absent Deduction",
                        "Overtime"
                      ].includes(data.Head);
                      
                      return (
                        <td className="rdt_TableCell tablecell voucherCell text-end" key={head}>
                          {head === "Overtime" || head === "Absent Deduction" ? (
                            <input
                              type="text"
                              className="form-control form-control-sm voucher-input text-end"
                              name={head === "Overtime" ? "OverTimeCt" : "AbsentCt"}
                              value={head === "Overtime" 
                                ? (data?.OverTimeCt || "0") 
                                : (data?.AbsentCt || "0")
                              }
                              onChange={e => handleInputChange(
                                fullName, 
                                head, 
                                head === "Overtime" ? "OverTimeCt" : "AbsentCt", 
                                e.target.value
                              )}
                              onKeyPress={handleKeyPress}
                            />
                          ) : (
                            <input
                              type="text"
                              className="form-control form-control-sm voucher-input text-end"
                              name="Amount"
                              value={data?.Amount || "0.00"}
                              onChange={e => handleInputChange(fullName, head, "Amount", e.target.value)}
                              onKeyPress={handleKeyPress}
                              disabled={autoCalculated}
                            />
                          )}
                        </td>
                      );
                    })}
                    <td className="rdt_TableCell tablecell voucherCell reportTotal sticky-right text-end fw-bold">
                      {getRowTotal(staffData[fullName])}
                    </td>
                  </tr>
                ))}
              </tbody>

              <tfoot style={{ position: "sticky", bottom: "-1px" }}>
                <tr className="reportTotal">
                  <td colSpan="3" className="rdt_TableCell tablecell text-end fw-bold">
                    {mode === "en" ? "Total" : "कुल"}
                  </td>
                  {allHeads.map(head => (
                    <td className="rdt_TableCell tablecell text-end fw-bold" key={head}>
                      {getColumnTotal(head)}
                    </td>
                  ))}
                  <td className="rdt_TableCell tablecell text-end sticky-right fw-bold">
                    {getGrandTotal()}
                  </td>
                </tr>
              </tfoot>
            </table>
          ) : (
            <p className="text-center">
              {mode === "en" ? "No Data" : "डाटा उपलब्ध छैन"}
            </p>
          )}
        </div>
      </div>

      {confirmPopup && (
        <ConfirmDetetePopup
          FormData={{
            AuthCode: User.AuthCode,
            ComID: User.ComID,
            UserID: User.UID.toString(),
            CID: "1",
            Flag: "D",
            MonthNp: `${formValues.year}/${formValues.month}`,
            FetchURL: `${appURL}api/acc/admin/payroll-generate`,
            Type: "POST",
          }}
          setTrigger={setConfirmPopup}
          message={mode === "en" 
            ? "Are you sure you want to delete ?" 
            : " के तपाइँ मेटाउन चाहनुहुन्छ"}
        />
      )}
      <ToastContainer />
    </div>
  );
}